import React from 'react';
import Schedina from './Schedina';
import UltimeGiocate from './UltimeGiocate';
import './UltimeGiocate.css';
import {caricaProfilo, caricaSchedinaSkin, motivoProfiloMancante,
  fraQuantoRichiedere}
  from '../../services/profiloDiGioco';
import {giocatoriDi} from '../../services/giocatoriApi';
import {
  componiRichiesta,
  inviaGiocata,
  nuovaChiave,
  descriviErrore,
} from './inviaGiocata';
import {getCurrentUserId, getCurrentNetworkLevel} from '../../utils/currentUser';
import {prenotaGiocata, linkDi} from '../../services/prenotazioniApi';
import {regoleDi, useRegoleStampaConStato} from '../../services/regoleStampa';
import i18next from 'i18next';

/* Dopo un rinfresco del profilo non riuscito si riprova fra mezzo minuto,
   non subito: se il servizio e' in affanno, mille schedine che riprovano
   ogni secondo sono il modo di non farlo rialzare. */
const RIPROVA_PROFILO_MS = 30000;

/**
 * La schedina attaccata al mondo vero.
 *
 * Schedina non sa niente di rete: riceve le selezioni e restituisce gesti.
 * Qui si fanno le quattro cose che toccano l'esterno -- capire chi sta
 * giocando, chiedere il profilo, mandare la giocata, dire cosa e' andato
 * storto -- cosi' la parte che si disegna resta provabile senza un server.
 */
export default function SchedinaCollegata({
  allBets,
  onTogli,
  onSvuota,
  /* Riapre una prenotazione dal codice: la strada e' UNA e sta nel
     contenitore, perche' e' lui che tiene le selezioni -- la stessa che
     usa il collegamento /p/<codice>. Torna {ok, testo, importo, codice}. */
  onApriPrenotazione,
}) {
  const [profilo, setProfilo] = React.useState(null);
  /* La giocata prenotata: niente finche' nessuno preme Prenota. */
  const [prenotata, setPrenotata] = React.useState(null);
  /* L'importo di una prenotazione riaperta, da scrivere nella casella. */
  const [importoProposto, setImportoProposto] = React.useState(null);
  /* Perche' il profilo non e' arrivato. Senza, la schedina puo' solo dire
     "riprova fra poco", che a chi guarda non dice niente e a chi deve
     sistemarlo nemmeno. */
  const [perche, setPerche] = React.useState(null);
  const [giocatori, setGiocatori] = React.useState([]);
  const [scelto, setScelto] = React.useState('');
  const [giro, setGiro] = React.useState(false);
  const [inCorso, setInCorso] = React.useState(false);
  const [esito, setEsito] = React.useState(null);
  /* Sale di uno a ogni giocata registrata: la striscia delle ultime giocate
     qui sotto la rilegge subito, senza aspettare il suo giro. */
  const [versione, setVersione] = React.useState(0);
  /* IL PROFILO SCADE, E SI RICHIEDE DA SOLO. Sale di uno ogni volta che va
     richiesto di nuovo: alla scadenza, quando il servizio ha rifiutato una
     giocata perche' il banco e' chiuso, o per riprovare dopo un rinfresco
     andato male. `falliti` conta i rinfreschi andati male di fila. */
  const [daRichiedere, setDaRichiedere] = React.useState(0);
  const [falliti, setFalliti] = React.useState(0);
  /* Di chi e' il profilo che c'e' adesso nello stato. Serve a distinguere un
     RINFRESCO (stesso intestatario) da un primo caricamento. */
  const diChi = React.useRef(null);
  /* Com'era il banco nell'ultimo profilo arrivato (aperto true/false, o
     null): serve a vedere la RIAPERTURA, cioe' il passaggio da chiuso ad
     aperto, e in quel momento togliere un rifiuto della notte rimasto scritto. */
  const bancoDiPrima = React.useRef(null);

  const io = getCurrentUserId();
  const chi = chiSono();

  /* La CHIAVE della compilazione: nasce con la prima selezione e muore
     quando la schedina si svuota. Due clic sullo stesso pulsante arrivano al
     server con la stessa chiave, e il secondo viene riconosciuto invece di
     diventare una seconda giocata e un secondo addebito. */
  const chiave = React.useRef(null);
  if (allBets && allBets.length > 0 && !chiave.current) {
    chiave.current = nuovaChiave();
  }
  if ((!allBets || allBets.length === 0) && chiave.current) {
    chiave.current = null;
  }

  /* Il profilo si chiede sul GIOCATORE intestatario, non su chi compila:
     quando un'agenzia gioca per un suo giocatore valgono i limiti del
     giocatore, perche' la scommessa e' sua. */
  const intestatario = chi === 'agenzia' ? scelto : io;

  /* LE REGOLE DI STAMPA E CONDIVISIONE DELLA PRENOTAZIONE sono di CHI
     GUARDA, non del giocatore per cui si compila: un'agenzia che prenota per
     un cliente (o per chi entra senza conto) stampa sul suo rotolo e
     condivide coi suoi canali.
       - l'ospite: la schedina pubblica della skin, gia' qui (`profilo`);
       - chi compila per se': il suo profilo, gia' qui (`profilo`);
       - l'agenzia: il SUO profilo, che qui non c'e' (`profilo` e' del
         cliente scelto, o della skin se non ne ha scelto uno). Si legge solo
         mentre la maschera della prenotazione e' aperta, e senza toccare i
         colori e le regole delle quote, che restano quelli del cliente. */
  const regoleSue = !io || intestatario === io;
  const chiCompila = useRegoleStampaConStato(io, {
    carica: !regoleSue && Boolean(prenotata && prenotata.pronta),
  });
  const regoleStampa = regoleSue ? regoleDi(profilo) : chiCompila.regole;
  const regoleInArrivo = !regoleSue && chiCompila.inArrivo;

  React.useEffect(() => {
    let vivo = true;
    if (!intestatario) {
      diChi.current = null;
      /* NESSUN INTESTATARIO = VISITATORE. Non ha limiti da rispettare perche'
         non puo' giocare, ma la tabella del bonus della skin la deve vedere:
         senza, compila una sestina, non vede niente, entra, e lo stesso coupon
         vale di piu'. Il numero che cambia sotto gli occhi e' peggio di un
         numero che manca.
         Niente motivo d'errore: per un ospite il profilo non manca, non
         esiste. */
      caricaSchedinaSkin().then((s) => {
        if (!vivo) return;
        setProfilo(s);
        setPerche(null);
      });
      return () => { vivo = false; };
    }
    /* SI CHIEDE IL PROFILO «DI ADESSO»: quello risolto secondo lo stato del
       banco in questo momento, che e' lo stesso con cui il servizio
       controllera' la giocata. A banco chiuso porta i tetti della notte. */
    caricaProfilo(intestatario, 'PREMATCH', 'ADESSO').then((p) => {
      if (!vivo) return;
      if (!p && diChi.current === intestatario) {
        /* UN RINFRESCO NON RIUSCITO NON SPEGNE LA SCHEDINA. Il profilo di
           prima l'ha mandato il servizio e resta il meglio che abbiamo: non
           e' un numero inventato qui. Buttarlo via per un colpo di rete
           spegnerebbe il tasto a chi sta compilando. Si riprova fra poco, e
           se intanto i limiti sono cambiati lo dice il servizio all'invio,
           col motivo. */
        setFalliti((n) => n + 1);
        return;
      }
      diChi.current = p ? intestatario : null;
      setFalliti(0);
      setProfilo(p);
      setPerche(p ? null : motivoProfiloMancante());
      /* IL BANCO HA RIAPERTO: un «Banco chiuso...» rimasto scritto da un
         rifiuto di prima adesso sarebbe falso. E nel modo «solo i limiti»
         il rifiuto della notte e' quello di giorno («L'importo massimo per
         questa giocata e' 500»): lo si riconosce dal limite che nomina, e
         se e' rimasto scritto da quando il banco era chiuso se ne va con la
         riapertura, perche' quel massimo adesso non vale piu'. Gli altri
         esiti restano. */
      const eraChiuso = bancoDiPrima.current === false;
      bancoDiPrima.current = p && p.banco ? p.banco.aperto : null;
      if (p && p.banco && p.banco.aperto === true) {
        setEsito((e) => (e && (e.bancoChiuso || (e.limite && eraChiuso)) ? null : e));
      }
    });
    return () => { vivo = false; };
  }, [intestatario, daRichiedere]);

  /* LA SCADENZA. Il profilo dice da solo fino a quando vale (`valeFinoA`):
     pochi minuti, oppure meno se il banco sta per cambiare stato. Alle 23:00
     una schedina gia' compilata deve scoprire i tetti della notte nel momento
     in cui cominciano a valere, e alle 08:00 smettere di mostrarli -- senza
     che nessuno ricarichi la pagina.

     COSA NON FA: non richiede se la scheda non la sta guardando nessuno
     (aspetta che torni in vista e chiede allora), non richiede per l'ospite
     (la schedina della skin non scade), e non richiede se il profilo non
     dice quando scade. */
  React.useEffect(() => {
    if (!intestatario || !profilo || diChi.current !== intestatario) {
      return undefined;
    }
    const fra = falliti > 0 ? RIPROVA_PROFILO_MS : fraQuantoRichiedere(profilo);
    if (fra == null) return undefined;

    let finito = false;
    let quandoTorna = null;
    const richiedi = () => {
      if (finito) return;
      finito = true;
      setDaRichiedere((n) => n + 1);
    };
    const orologio = setTimeout(() => {
      if (typeof document !== 'undefined' && document.hidden) {
        quandoTorna = () => { if (!document.hidden) richiedi(); };
        document.addEventListener('visibilitychange', quandoTorna);
        return;
      }
      richiedi();
    }, fra);

    return () => {
      finito = true;
      clearTimeout(orologio);
      if (quandoTorna) {
        document.removeEventListener('visibilitychange', quandoTorna);
      }
    };
  }, [profilo, intestatario, falliti]);

  React.useEffect(() => {
    let vivo = true;
    if (chi !== 'agenzia' || !io) return undefined;
    giocatoriDi(io).then((elenco) => {
      if (vivo) setGiocatori(elenco);
    });
    return () => { vivo = false; };
  }, [chi, io]);

  async function gioca(dati) {
    if (inCorso) return;
    setInCorso(true);
    setEsito(null);

    const richiesta = componiRichiesta(Object.assign({}, dati, {
      utente: intestatario,
      chiave: chiave.current,
      giroAutomatico: giro,
    }));

    const risposta = await inviaGiocata(richiesta);
    setInCorso(false);

    if (risposta.ok) {
      /* Registrata e in attesa sono due esiti diversi, e vanno detti diversi:
         chi crede di aver giocato e non vede la giocata in corso, la rifa'. */
      setEsito(risposta.inAttesa
          ? {buona: true, attesa: true, testo: attesaDi(risposta.ticket)}
          : {buona: true, testo: codiceDi(risposta.ticket)});
      chiave.current = null;
      if (onSvuota) onSvuota();
      /* E' partita: la striscia qui sotto e la spia in alto lo sanno subito.
         L'evento sulla finestra serve a chi non conosce questa schedina. */
      setVersione((v) => v + 1);
      window.dispatchEvent(new Event('giocataCambiata'));
      return;
    }

    /* LA CHIAVE SI CAMBIA SOLO QUANDO SI SA CHE LA GIOCATA NON C'E'.
       Serve a impedire che due clic diventino due giocate, non a impedire un
       secondo tentativo dopo un rifiuto: quello e' un tentativo nuovo, e
       tenendo la vecchia chiave il server lo riconoscerebbe come reinvio per
       sempre.
       Ma ci sono tre risposte dopo le quali la giocata POTREBBE esserci, e
       li' la chiave non si tocca: se cambiasse, il clic dopo ne manderebbe
       una seconda senza che niente la riconosca.
         RETE            - il server non ha risposto affatto
         TICKET_IN_CORSO - la prima richiesta e' ancora la' che lavora
         TICKET_ALREADY_SENT - c'e' gia', ed e' registrata
       Elencare i casi in cui NON si cambia, invece dei casi in cui si cambia,
       e' voluto: un codice nuovo che non conosciamo cade fra i sicuri, e la
       conseguenza di sbagliare da quella parte e' una giocata in meno, non
       una di troppo. */
    const forse = ['RETE', 'TICKET_IN_CORSO', 'TICKET_ALREADY_SENT'];
    if (risposta.errore && forse.indexOf(risposta.errore.code) === -1) {
      chiave.current = nuovaChiave();
    }

    /* RIFIUTATA PER UN LIMITE CHE LA SCHEDINA NON SAPEVA: aveva in mano un
       profilo di prima -- la fascia e' entrata nello stesso secondo, o
       qualcuno ha chiuso il banco a mano, che non ha un orario da conoscere
       in anticipo, o un limite e' cambiato. Il profilo si richiede subito,
       cosi' i massimi sotto l'importo si aggiornano e il tasto dice la
       verita'. Vale quando il servizio dice «banco chiuso» e quando rifiuta
       col codice di un limite di giorno: nel modo «solo i limiti» a banco
       chiuso arriva proprio quello, e dal sito non si distingue. La giocata
       non e' nata e il conto non e' stato toccato: non c'e' nient'altro da
       rimettere a posto. */
    const bancoChiuso = Boolean(risposta.errore && risposta.errore.bancoChiuso);
    if (bancoChiuso || (risposta.errore && risposta.errore.limite)) {
      setDaRichiedere((n) => n + 1);
    }

    /* Il CODICE accanto al messaggio: il numero da solo non dice niente a chi
       guarda, e un 403 puo' essere dieci cose diverse. */
    setEsito({
      buona: false,
      testo: descriviErrore(risposta.errore),
      bancoChiuso,
      /* Quale tetto l'ha fermata, se e' uno di quelli che la schedina
         conosce: sotto non ripete la stessa riga. */
      limite: (risposta.errore && risposta.errore.limite) || null,
    });
  }

  /* PRENOTARE: la stessa richiesta di una giocata, sulla rotta aperta.
     Niente chiave nuova dopo un rifiuto: qui non ci sono soldi, e la chiave
     serve solo a far riconoscere il doppio clic. */
  async function prenota(dati) {
    if (inCorso) return;
    setInCorso(true);
    setEsito(null);
    const richiesta = componiRichiesta(Object.assign({}, dati, {
      utente: intestatario || null,
      chiave: chiave.current,
      giroAutomatico: false,
    }));
    richiesta.potentialWinMax = Number(dati.vincitaVista) > 0 ? dati.vincitaVista : null;

    const r = await prenotaGiocata(richiesta);
    setInCorso(false);
    if (r.ok && r.prenotazione && r.prenotazione.codice) {
      const pr = r.prenotazione;
      setPrenotata({
        pronta: true,
        codice: pr.codice,
        scadeIl: pr.scadeIl,
        scadenzaPerche: pr.scadenzaPerche,
        link: linkDi(pr.codice),
        riepilogo: dati.riepilogo || null,
        /* Per il messaggio, la stampa e l'immagine della prenotazione: la
           schedina qui sotto si svuota, e quello che c'era resta solo qui. */
        selezioni: pr.selezioni || [],
        tipo: pr.tipo || null,
        creataIl: pr.creataIl || null,
        importo: pr.importo != null ? pr.importo : null,
        vincitaVista: pr.vincitaVista != null ? pr.vincitaVista : null,
        primoEvento: pr.primoEvento || null,
      });
      /* PRENOTATA, LA SCHEDINA SI SVUOTA, come dopo una giocata: le quote
         ora stanno nel codice. Prima restavano li', il numero sul tasto
         Schedina diceva che c'era ancora qualcosa e riaprendola si
         ritrovava la maschera del codice. Il codice resta in vista finche'
         non si torna alla schedina o non si chiude il pannello. */
      chiave.current = null;
      if (onSvuota) onSvuota();
      return;
    }
    setPrenotata({pronta: false, motivo: descriviErrore(r.errore)});
  }

  /* Chiuso il pannello della schedina (guscio Nova, telefono), la maschera
     del codice se ne va: riaprendo si trova la schedina, non la prenotazione
     di prima. */
  React.useEffect(() => {
    const chiusa = () => setPrenotata(null);
    window.addEventListener('schedinaChiusa', chiusa);
    return () => window.removeEventListener('schedinaChiusa', chiusa);
  }, []);

  /* RIAPRIRE DAL CODICE scritto nella schedina vuota. */
  async function apriCodice(codice) {
    if (!onApriPrenotazione) return;
    setEsito(null);
    const r = await onApriPrenotazione(codice);
    setEsito({buona: r.ok, attesa: false, testo: r.testo});
    if (r.ok && r.importo != null) {
      setImportoProposto({importo: r.importo, chiave: `${r.codice}-${Date.now()}`});
    }
  }

  /* ...e dal collegamento /p/<codice>, che passa dal contenitore: lui
     carica le selezioni e qui si scrive solo cosa e' successo. */
  React.useEffect(() => {
    const arrivata = (e) => {
      const d = (e && e.detail) || {};
      setEsito({buona: Boolean(d.ok), attesa: false, testo: d.testo || ''});
      if (d.ok && d.importo != null) {
        setImportoProposto({importo: d.importo, chiave: `${d.codice}-${Date.now()}`});
      }
    };
    window.addEventListener('prenotazioneAperta', arrivata);
    return () => window.removeEventListener('prenotazioneAperta', arrivata);
  }, []);

  return (
    <>
    <Schedina
      selezioni={allBets || []}
      profilo={profilo}
      chi={chi}
      giocatori={giocatori}
      giocatoreScelto={scelto}
      onGiocatore={setScelto}
      motivoProfilo={perche}
      giroAutomatico={giro}
      onGiro={setGiro}
      onTogli={onTogli}
      onSvuota={() => { chiave.current = null; if (onSvuota) onSvuota(); }}
      onGioca={gioca}
      prenotata={prenotata}
      regoleStampa={regoleStampa}
      regoleInArrivo={regoleInArrivo}
      onChiudiPrenotata={() => setPrenotata(null)}
      onPrenota={prenota}
      onCodice={apriCodice}
      importoProposto={importoProposto}
      inCorso={inCorso}
      esito={esito}
    />
    {/* LE ULTIME GIOCATE, sotto il tasto: quello che e' gia' partito. Si
        accende dal backoffice (profilo.ultimeGiocate) e la vede chi gioca o
        compila per altri: con un ospite non c'e' niente da mostrare. */}
    <UltimeGiocate profilo={profilo} chi={chi} io={io} versione={versione} />
    </>
  );
}

/**
 * Chi sta compilando.
 *
 * Solo i giocatori possono giocare: chi ha una rete compila per uno dei suoi,
 * e chi non ha un conto puo' solo prenotare.
 */
/**
 * Chi sta compilando la schedina.
 *
 * IL LIVELLO SI LEGGE DAL GETTONE, non da localStorage. Prima si leggeva
 * USER_ROLE, e l'elenco di chi conta come giocatore comprendeva la STRINGA
 * VUOTA: bastava che quella voce mancasse -- ed e' scritta solo se una certa
 * chiamata al profilo riesce -- perche' un'agenzia venisse trattata da
 * giocatore e potesse giocare per se'. E' successo davvero.
 *
 * Il verso del ripiego era sbagliato: "non so che livello sei" finiva su
 * "giocatore", che e' l'unico livello a cui e' permesso giocare. Adesso va
 * dall'altra parte: chi non si riconosce compila per qualcun altro, e per
 * farlo deve scegliere il giocatore dalla tendina. Nel peggiore dei casi si
 * chiede un passaggio in piu'; prima, nel peggiore dei casi, si intestava una
 * giocata a chi non poteva averla.
 *
 * Il server non si fida comunque di questa funzione: rifiuta una giocata
 * intestata a un livello che non puo' giocare. Questa serve a non far
 * arrivare la persona fino al rifiuto.
 */
export function chiSono() {
  if (!getCurrentUserId()) {
    return 'ospite';
  }
  const livello = String(getCurrentNetworkLevel() || '')
      .toUpperCase().replace(/-/g, '_');

  /* TRE RUOLI, non due, perche' i livelli sono di tre specie.
     Gioca chi sta in fondo. Compila per un altro SOLO l'agenzia: e' lei che
     ha il rapporto con la persona, che incassa e che paga. Tutti gli altri --
     sub-agente, agente, master, azienda -- gestiscono chi sta sotto di loro e
     non giocano per nessuno, quindi la schedina per loro non e' uno strumento
     e la tendina dei giocatori non devono nemmeno vederla.
     Prima erano due, e chiunque non fosse un giocatore diventava "agenzia":
     un master si vedeva la tendina e poteva compilare, cosa che il server
     adesso rifiuta -- ma farglielo scoprire dopo aver compilato tutta la
     schedina e' un modo brutto di dirglielo. */
  if (GIOCA.indexOf(livello) !== -1) return 'giocatore';
  if (COMPILA.indexOf(livello) !== -1) return 'agenzia';
  return 'nonGioca';
}

/* Chi puo' avere una giocata intestata, e chi puo' compilarla per un altro.
   Il server decide comunque per conto suo: questi due elenchi servono a non
   far arrivare la persona fino al rifiuto. */
const GIOCA = ['PLAYER', 'WEB_USER', 'GIOCATORE'];
const COMPILA = ['AGENZIA'];

function codiceDi(ticket) {
  const codice = ticket && (ticket.ticketCode || ticket.code);
  return codice ? `Giocata registrata · ${codice}` : 'Giocata registrata';
}

/* LA FRASE LA SCRIVE IL SERVER, qui non se ne inventa una: il catalogo manda
   message gia' composto col codice dentro, e il ripiego serve solo se quel
   campo non arriva. Il MOTIVO della riserva non c'e' e non ci deve essere --
   quello resta al backoffice. */
function attesaDi(ticket) {
  if (ticket && ticket.message) {
    return ticket.message;
  }
  const codice = ticket && ticket.params && ticket.params.codice;
  return codice
    ? i18next.t('In attesa di accettazione · {{codice}}', {codice})
    : i18next.t('In attesa di accettazione');
}
